export const appConfig = {
    // apiUrl: 'https://epath.me/aa/public/api/',
    // publicUrl: 'https://epath.me/aa/public/'

  	// publicUrl:'http://localhost/epath/public/',
    // apiUrl: 'http://localhost/epath/public/api/'

   // apiUrl: 'https://www.demo.epath.me/api/public/api/',
   // publicUrl: 'https://www.demo.epath.me/api/public/'

   apiUrl: 'https://'+window.location.hostname+'/api/public/api/',
   publicUrl: 'https://'+window.location.hostname+'/api/public/'

};



// WEBPACK FOOTER //
// ./src/app/app.config.ts